
define('ldsh!modules/lp_leads/templates/lead_column', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<td class="' +
((__t = (className)) == null ? '' : __t) +
'">' +
__e(value) +
'</td>\n';

}
return __p
};});

